var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountBalance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4958_10547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.24667V1.91667C11.25 1.275 10.725 0.75 10.0833 0.75H1.91667C1.26917 0.75 0.75 1.275 0.75 1.91667V10.0833C0.75 10.725 1.26917 11.25 1.91667 11.25H10.0833C10.725 11.25 11.25 10.725 11.25 10.0833V8.75333C11.5942 8.54917 11.8333 8.18167 11.8333 7.75V4.25C11.8333 3.81833 11.5942 3.45083 11.25 3.24667ZM10.6667 4.25V7.75H6.58333V4.25H10.6667ZM1.91667 10.0833V1.91667H10.0833V3.08333H6.58333C5.94167 3.08333 5.41667 3.60833 5.41667 4.25V7.75C5.41667 8.39167 5.94167 8.91667 6.58333 8.91667H10.0833V10.0833H1.91667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 6.875C8.81626 6.875 9.20801 6.48325 9.20801 6C9.20801 5.51675 8.81626 5.125 8.33301 5.125C7.84976 5.125 7.45801 5.51675 7.45801 6C7.45801 6.48325 7.84976 6.875 8.33301 6.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4958_10547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(-1 -1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalance);
export default __webpack_public_path__ + "static/media/account_balance.8603b075ca8d35b1baa496b8ddb0777e.svg";
export { ForwardRef as ReactComponent };